module.exports = __webpack_public_path__ + "img/2.188fa62f.jpg";